'use client';

import React from 'react';
import LightweightCarousel from './LightweightCarousel';

const BANNER_SLIDES = [
  // Only the Performance Airflow, Ford, Pedal Power Kit, Save Gas and
  // America 250 campaigns are live for now; the other slides are kept
  // commented out so they can be restored later.
  {
    id: 10,
    imageSrc: '/assets/banner/hero/performance-airflow-desktop.webp',
    imageAlt: 'Performance starts with airflow. High-flow, washable, reusable, built for performance. Find your filter.',
    link: '/corvette-air-filters/',
  },
  {
    id: 9,
    imageSrc: '/assets/banner/hero/ford-performance-desktop.webp',
    imageAlt: 'High performance filters for Ford. More air. More power. Built to perform. Shop Ford filters.',
    link: '/brand/ford',
  },
  {
    id: 7,
    imageSrc: '/assets/banner/hero/power-pedal-kit-v3-desktop.webp',
    imageAlt: 'Power Pedal Kit: instant throttle response. Plug-and-play performance upgrade. Eliminate lag, unleash power. Shop now.',
    link: '/power-pedal-kit',
  },
  {
    id: 8,
    imageSrc: '/assets/banner/hero/save-gas-desktop.webp',
    imageAlt: 'Save gas. Boost performance. Green Filter USA.',
    link: '/shop-by-vehicle',
  },
  {
    id: 2,
    // No mobileImageSrc: on phones every live slide shows its wide desktop
    // artwork, so they all share one height. america-250-mobile.webp is
    // kept for when the other campaigns get portrait versions too.
    imageSrc: '/assets/banner/hero/america-250-v2-desktop.webp',
    imageAlt: 'America 250. Celebrating 250 years of the United States.',
    link: '/shop-by-vehicle',
  },
  // {
  //   id: 1,
  //   imageSrc: '/assets/banner/hero/green-banner-1-desktop.webp',
  //   mobileImageSrc: '/assets/banner/hero/green-banner-1-mobile.webp',
  //   imageAlt: 'Built for better airflow. Washable. Reusable. Built for the drive. Find your filter.',
  //   link: '/shop-by-vehicle',
  // },
  // {
  //   id: 3,
  //   imageSrc: '/assets/banner/hero/green-banner-2-desktop.webp',
  //   mobileImageSrc: '/assets/banner/hero/green-banner-2-mobile.webp',
  //   imageAlt: 'Heavy duty power. Cleaner airflow. Washable. Reusable. Built for the long haul. Find your filter.',
  //   link: '/shop-by-vehicle',
  // },
  // {
  //   id: 4,
  //   imageSrc: '/assets/banner/hero/green-banner-4-desktop.webp',
  //   mobileImageSrc: '/assets/banner/hero/green-banner-4-mobile.webp',
  //   imageAlt: 'Built for airflow. Ready for the road. Washable. Reusable. Built for everyday performance. Find your filter.',
  //   link: '/shop-by-vehicle',
  // },
  // {
  //   id: 5,
  //   imageSrc: '/assets/banner/hero/green-banner-3-desktop.webp',
  //   mobileImageSrc: '/assets/banner/hero/green-banner-3-mobile.webp',
  //   imageAlt: 'More air. More drive. Washable. Reusable. Made for everyday power. Find your filter.',
  //   link: '/shop-by-vehicle',
  // },
];

/**
 * Promotional Banner Component
 * Uses lightweight CSS-only carousel instead of react-multi-carousel (saves ~1.8MB)
 */
const PromotionalBanner = () => {
  return (
    <div data-testid="promotional-banner-carousel">
      <LightweightCarousel slides={BANNER_SLIDES} autoPlaySpeed={5000} />
    </div>
  );
};

export default PromotionalBanner;
